import { completeStage, selectStage } from '../redux/slices/stageSlice';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hook';

import { DarkButton } from './dark-button';
import Loading from './loading';
import { selectSession } from '../redux/slices/sessionSlice';
import styles from '../app/document-list/page.module.css';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';

function DocumentListForm(props: { onSelect: (doc: string) => void }) {
	const [lazyLoad, setLazyLoad] = useState(false);
	const dispatch = useAppDispatch();
	const { token, reservation, propertyInfo } = useAppSelector(selectSession);
	const { stages, stage } = useAppSelector(selectStage);

	const [complete, setComplete] = useState(false);
	const [showOtpScreen, setShowOtpScreen] = useState(false);
	const [email, setEmail] = useState('');
	const [otp, setOtp] = useState(['', '', '', '']);
	const [selectedDoc, setSelectedDoc] = useState<
		'passport' | 'emiratesId' | null
	>('passport');

	useEffect(() => {
		if (selectedDoc) {
			props.onSelect(selectedDoc);
		}
	}, [selectedDoc]);

	useEffect(() => {
		if (complete) {
			dispatch(
				completeStage({
					token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages,
					propertyCode: propertyInfo?.propertyCode ?? '',
				})
			);
		}
	}, [complete]);

	const handleOtpChange = (value: string, index: number) => {
		if (!/^\d?$/.test(value)) return;

		const newOtp = [...otp];
		newOtp[index] = value;
		setOtp(newOtp);

		// auto-focus next input
		const nextInput = document.getElementById(`otp-${index + 1}`);
		if (value && nextInput) nextInput.focus();
	};

	return (
		<>
			{/* PAGE CONTENT */}
			<div className="container pt-4 pb-5 vh-100">
				{/* HEADER */}
				<div
					className="d-flex justify-content-center align-items-center w-100 theme-header"
					style={{ minHeight: '80px' }}
				/>
				{/* Title */}
				<h2 className="doc-select-title text-center">
					{t('DocumentListTitle')}
				</h2>

				{/* Description */}
				<p className="doc-select-description text-center">
					{t('DocumentListDescription')}
				</p>

				{/* Document cards */}
				<div className="doc-card-list mt-4">
					{/* Passport */}
					<label
						className={`doc-card ${
							selectedDoc === 'passport' ? 'active' : ''
						}`}>
						<input
							type="radio"
							name="documentType"
							value="passport"
							checked={selectedDoc === 'passport'}
							onChange={() => setSelectedDoc('passport')}
							className="doc-radio"
						/>

						<div className="doc-card-content">
							<div className="doc-card-icon passport-icon" />
							<span className="doc-card-text">{t('DocumentListPassport')}</span>
						</div>
					</label>

					{/* Emirates ID */}
					<label
						className={`doc-card ${
							selectedDoc === 'emiratesId' ? 'active' : ''
						}`}>
						<input
							type="radio"
							name="documentType"
							value="emiratesId"
							checked={selectedDoc === 'emiratesId'}
							onChange={() => setSelectedDoc('emiratesId')}
							className="doc-radio"
						/>

						<div className="doc-card-content">
							<div className="doc-card-icon emirates-icon" />
							<span className="doc-card-text">
								{t('DocumentListEmiratesID')}
							</span>
						</div>
					</label>
				</div>
			</div>
		</>
	);
}

export default DocumentListForm;
